import { render, staticRenderFns } from "./FileRow.vue?vue&type=template&id=5fcf04d2&"
import script from "./FileRow.vue?vue&type=script&lang=js&"
export * from "./FileRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports